module.exports = __webpack_public_path__ + "static/media/ptaki.98864612.mp4";